/**
 * 자동 로그인 선택.
 *
 * 실제 로그인 상태는 서버가 심은 httpOnly 쿠키가 쥐고 있다.
 * 여기에는 "이 브라우저가 자동 로그인을 골랐다"는 사실만 남겨,
 * 브라우저를 껐다 켠 뒤에도 세션을 되살릴지 판단하는 데 쓴다.
 */
export type AutoLoginScope = 'member' | 'seller' | 'admin'

const STORAGE_KEY: Record<AutoLoginScope, string> = {
  member: 'jangi.autoLogin.member',
  seller: 'jangi.autoLogin.seller',
  admin: 'jangi.autoLogin.admin',
}

export function loadAutoLogin(scope: AutoLoginScope): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY[scope]) === '1'
  } catch {
    return false
  }
}

export function saveAutoLogin(scope: AutoLoginScope, on: boolean) {
  try {
    if (on) {
      localStorage.setItem(STORAGE_KEY[scope], '1')
      return
    }
    localStorage.removeItem(STORAGE_KEY[scope])
  } catch {
    /* 시크릿 모드 등 저장소가 막힌 환경에서는 조용히 넘어간다 */
  }
}
